require('./components/polyfill');

// jQuery Setup
window.$ = require('jquery');
window.jQuery = window.$;	// alias for Bootstrap

// embedd bootstrap's JS for modal etc.
require('./components/tooltips');

import NP_TM from './components/np-tagmanager';
import FormFieldHandle from './components/formInputHandle';
import initAccordions from './components/accordions';
import initModals from './components/modals';
import MobileNavigation from "./components/mainNavi";

(function () {
	new FormFieldHandle();
	initAccordions();
	initModals();

	// Google Tag-Manager
	window.tag = new NP_TM({
		manualAttachments: (_this) => {
			
		}
	});

	//main-navigation
	new MobileNavigation({
		selectorNavi: '.js-mainNavi',
		selectorNaviToggle: '.js-mainNaviToggle',
		cssClassBody: 'mainnavi-toggled'
	});
})();